import { Navigate, Outlet, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';
import Loader from './components/Loader';
import clsx from 'clsx';

const PublicRoute = () => {
  const onboardingLayoutClasses = clsx(
    'min-h-screen bg-neutral-tones-background overflow-hidden relative flex flex-col',
  );
  const { isAuthenticated, loading } = useSelector(
    (node: { userLogin: RootState['userLogin'] }) => node?.userLogin,
  );
  const location = useLocation();
  const query = new URLSearchParams(location?.search);
  const redirectTo = query.get('redirect');

  return isAuthenticated ? (
    <Navigate to={redirectTo || '/dashboard'} replace />
  ) : loading ? (
    <Loader />
  ) : (
    <div className={onboardingLayoutClasses} data-testid="onboarding-layout">
      <Outlet />
      <img
        src="/assets/images/logo.png"
        alt="logo"
        className="absolute -bottom-32 left-2/4 max-w-406 min-w-406 -translate-x-2/4 opacity-[0.07] md:-bottom-644 md:min-w-1000 lg:-right-14 lg:-bottom-56 lg:max-h-1000 lg:w-full lg:max-w-812 lg:min-w-min lg:translate-x-0 lg:rotate-[15deg]"
      />
    </div>
  );
};

export default PublicRoute;
